const environment = {
    production: false,
    staging: false,
    userLocalStorageKey: 'labelcall.currentUser',
    clientId: 'labelcall.portal',
    backendUrl: '',
    apiPrefix: '/portal/v1.0',
    stripeKey: 'pk_test_MEbOzBC5JQNJvtcLvggiWcue008A0EvQUh',
    apiDocumentationLink: '/api-docs/index.html',
    gtmCode: 'GTM-NO-NEEDED-ON-LOCAL',
    mode: 'local',
    instrumentationKey: ''
};

export default environment;

export function updateEnvironment(values: any) {
    environment.gtmCode = values.gtmCode;
    environment.mode = values.mode;
    environment.stripeKey = values.stripeKey;
    environment.production = values.mode === 'production';
    environment.staging = values.mode === 'staging';
    environment.instrumentationKey = values.instrumentationKey;
}
